export const base = window.location.hostname.includes('localhost')
	? 'http://localhost:5567'
	: window.location.hostname.includes('test.amikohome.com')
		? 'http://test.amikohome.com'
		: 'https://www.amikohome.com';

export const store = 'AMIKOHOME';

const api = {
	slider: locale => `${base}/api/slider/all/${store}/${locale}`,
	featured: locale => `${base}/api/item/items/featured/${store}/${locale}`,
	product: (locale,type) => `${base}/api/item/items/${type}/${store}/${locale}`,
	article: (locale,limit) => `${base}/api/article/articles/${locale}/${store}` + (limit ? `?limit=${limit}` : ``),
	articleDetails: id => `${base}/api/article/article/${id}`,
	archive: locale => `${base}/api/item/items/archived/${store}/${locale}`,
	itemType: `${base}/api/item/items/types`,
	supportWebleaflets: locale => `${base}/api/support/support-files/${store}/WEBLEAFLET/${locale}`,
	supportUserManuals: locale => `${base}/api/support/support-files/${store}/USER_MANUAL/${locale}`,
	supportFirmwares: locale => `${base}/api/support/support-files/${store}/FIRMWARE/${locale}`,
	supportTutorials: locale => `${base}/api/support/support-files/${store}/TUTORIAL/${locale}`,
	query: (query, locale) => `${base}/api/item/search/${store}/${locale}?name=${query}`,
	contact: locale => `${base}/api/contact/send/${store}/${locale}`,
	prizegame: `${base}/api/prizegame/send/${store}`,
	landing: type => `${base}/api/landing/send/${type}/${store}`,
	landingWithMessage: type =>`${base}/api/landing/send/message/${type}/${store}`,
	productDetails: (id, locale) => `${base}/api/item/id/${id}/${store}/${locale}`,
	localeMessages: `${base}/api/translation/${store}`,
	language: `${base}/api/language/all/available/${store}`,
	geo: `https://extreme-ip-lookup.com/json/`,
};

export default api;


// WEBPACK FOOTER //
// ./src/config/api.js